import { Icon } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The confidentiality line carried by every question screen.
 *
 * Deliberately generic about who sees the data — "Your employer", not the
 * member's actual organisation — so there is nothing to fetch and nothing to
 * get wrong when the organisation is unknown.
 */
const PrivacyFooter = () => {
  const { t: translate } = useTranslation('homepage');

  return (
    <p className="label-s wellbeing-measure-modal__privacy">
      <Icon icon="locked" size="small" aria-hidden="true" />
      {translate('wellbeing_measure.privacy_notice')}
    </p>
  );
};

export default PrivacyFooter;
